import { render, staticRenderFns } from "./NovelList.vue?vue&type=template&id=e9138c64&scoped=true"
import script from "./NovelList.vue?vue&type=script&lang=ts"
export * from "./NovelList.vue?vue&type=script&lang=ts"
import style0 from "./NovelList.vue?vue&type=style&index=0&id=e9138c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9138c64",
  null
  
)

export default component.exports